import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemInOrderOutputDto } from 'src/generated_client';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit {

  displayedColumns: string[] = ['articulo','cantidad','precio'];
  Data: Elements = {
    items: [{}]
  };


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Elements,
  ) { }

  ngOnInit(): void {
    this.Data = this.data;
  }
  
  get Total() {
    return Number(this.Data.total);
  }

  get Delivery() {
    return Number(this.Data.delivery);
  }

  get Discount() {
    return Number(this.Data.discount);
  }
}

interface Elements {  
  items: Array<ItemInOrderOutputDto>;
  delivery?: number;
  discount?: number;
  total?: number;
  notes?: string;
}
